import React, { useMemo } from "react";

import { Helmet } from "react-helmet";
import { isMobile } from "react-device-detect";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";

import Tabs from "../components/tab/Tabs";

import DetailTab from "../components/single-campaign/DetailTab";
import StepTab from "../components/single-campaign/StepTab";

import { ModalContextProvider } from "../components/single-campaign/ModalContext";
import { CampaignContextProvider } from "../components/single-campaign/CampaignContext";

const SingleCampaign: React.FC = () => {
  const navItem = useMemo(
    () => [
      { title: "اطلاعات کمپین", target: "#nav-pill-campaign-detail-tab" },
      { title: "مراحل", target: "#nav-pill-campaign-steps-tab" },
    ],
    []
  );
  const tabContent = useMemo(
    () => [
      {
        id: "nav-pill-campaign-detail-tab",
        component: <DetailTab />,
      },
      {
        id: "nav-pill-campaign-steps-tab",
        component: (
          <ModalContextProvider>
            <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
              <StepTab />
            </DndProvider>
          </ModalContextProvider>
        ),
      },
    ],
    []
  );

  return (
    <CampaignContextProvider>
      <Helmet>
        <title>تک کمپین</title>
      </Helmet>
      <Tabs
        key="single-campaign-tabs"
        navItem={navItem}
        tabContent={tabContent}
        type="horizontal"
        className="position-relative"
        myFunction={() => {}}
      />
    </CampaignContextProvider>
  );
};

export default SingleCampaign;
